const uMouse = {
  value: new Vector2(-1, -1),
}

let initialized = false

export const useUniformMouse = () => {
  if (!initialized) {
    initialized = true

    const { renderer, sizes } = useTresContext()
    const { onLoop } = useRenderLoop()

    const canvas = computed(() => renderer.value.domElement)
    const { elementX: x, elementY: y, isOutside } = useMouseInElement(canvas)

    const ease = 0.18

    watch(
      () => isOutside.value,
      (isOutside, wasOutside) => {
        if (!isOutside && wasOutside) {
          uMouse.value.x = x.value / sizes.width.value
          uMouse.value.y = 1 - y.value / sizes.height.value
        }

        if (isOutside && !wasOutside) {
          uMouse.value.x = -1
          uMouse.value.y = -1
        }
      }
    )

    onLoop(() => {
      if (isOutside.value) return

      const to = {
        x: x.value / sizes.width.value,
        y: 1 - y.value / sizes.height.value,
      }

      uMouse.value.x += (to.x - uMouse.value.x) * ease
      uMouse.value.y += (to.y - uMouse.value.y) * ease
    })
  }

  return uMouse
}
